export const content = {
  breadcrumbRoot: 'Roaming & international',
  breadcrumbCurrent: 'Europe',
  breadcrumbMobile: 'Select another European country',
  heading: (country: string) => `Using SMARTY in ${country}`,
  goodNewsSubheading: (country: string) =>
    `Good news. ${country} is included when roaming within the EU.`,
  anywhereSubheading: 'Use your SMARTY plan anywhere in the EU.',
  callsAndTexts:
    "If your plan includes calls and texts, they work just like home. They're unlimited with no extra fees.",
  irelandDataAllowance:
    'Subject to our fair use policy, you can use your full monthly data allowance* when visiting Ireland. If you need more data, you can buy a data add-on.',
  standardDataAllowance:
    'Subject to our fair use limit, you can use up to 12GB of data each month out of your monthly allowance. If you need more data, you can buy a data add-on.',
  noHiddenCharges: 'No hidden charges. No extra costs.',
  priceGuideLinkText:
    'Please see our Price Guide for more information on our Fair Use Policy.',
  priceGuideAriaLabel: 'See all prices .PDF (253KB) link opens in a new window',
  priceGuideLink: '/priceguide',
  seeAllPrices: 'See all prices',
  callingAbroadPrompt: (country: string) =>
    `Need to call or text non-UK or Internationally from ${country}?`,
  irelandFootnote:
    '*This is to prevent customers being charged inadvertent roaming charges on the border.',
  cardHeading: 'Before you go',
  cardSubheading: 'Phone settings update required',
  cardBody:
    "Most customers can use their SMARTY SIM abroad without changing any phone settings. If your phone doesn't connect while you're away, we've created step-by-step guides to help get you up and running.",
  setupLinkText: 'Set up your phone now',
  setupLinkPath: '/roaming-setup',
  imageAlt: 'Europe',
  pageTitle: (country: string) => `Using SMARTY in ${country}`,
}
